import { render, staticRenderFns } from "./MIcon.vue?vue&type=template&id=3be81586"
import script from "./MIcon.vue?vue&type=script&lang=js"
export * from "./MIcon.vue?vue&type=script&lang=js"
import style0 from "./MIcon.vue?vue&type=style&index=0&id=3be81586&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports